export const wTwitterTweetMetaData = {
    isRepeatable: false
}
